
import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import draggable from 'vuedraggable'
import Multiselect from 'vue-multiselect'
import {namespace} from 'vuex-class'
import {optionsVslim} from '@/config/v-slim-dialog'
import {required} from 'vuelidate/lib/validators'
import {validationMixin} from 'vuelidate'
import {freshdeskEmail, isProduction} from '@/config/service'

const authModule = namespace('auth')
const prospectModule = namespace('prospect')
const mailModule = namespace('mail')
const documentModule = namespace('document')
const propositionModule = namespace('proposition')

@Component({
  components: {
    draggable,
    Multiselect
  },
  mixins: [validationMixin],
  validations: {
    sujetSelected: {
      required
    }
  }
})
export default class ProspectPanel extends Vue {
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @mailModule.Action('sendEmailAction') sendEmail: any
  @mailModule.Action('getMailBlocTextsAction') getMailBlocTexts: any
  @mailModule.Action('getMailSujetsAction') getMailSujets: any
  @mailModule.Action('getMailAdresseInternesAction') getMailAdresseInternes: any
  @documentModule.Action('getDocumentsGeneriquesAction') getDocumentsGeneriques: any
  @mailModule.Getter('mailSujetsGetter') mailSujets: any
  @mailModule.Getter('mailBlocTextsGetter') mailBlocs: any
  @mailModule.Getter('mailAdresseInternesGetter') mailAdresseInternes: any
  @authModule.Getter('meGetter') me: any
  @documentModule.Action('getDocumentAction') getDocument: any
  @Prop(Object) proposition!: any
  @Prop(Array) prospects!: any

  sujetSelected = ''
  contentTextArea = ''
  enabled = true
  dragging = false
  list = []
  documentsGeneriques = []
  documentsGeneriquesOptions = []
  isLoading = false
  contacts = []
  desti = []
  copie = []
  copieCachee = isProduction ? [freshdeskEmail] : []

  mounted() {
    this.contacts = this.prospects.flatMap((prospect) => prospect.CONTACTS)
    const contactsAllowed = this.contacts.filter((contact) => contact.EMAIL)
    this.desti = contactsAllowed
    this.getMailBlocTexts().then((data) => {
      const filterList = data.filter((item) => item.CONTEXTE_BULK === 1)
      if (filterList.length > 0) {
        const d = []
        filterList.map((item) => {
          d.push({...item, DEFAUT: item.DEFAUT_BULK})
        })
        this.list = d
      } else {
        this.list = filterList
      }
    })
    this.getMailSujets()
    this.getMailAdresseInternes()
    this.getDocumentsGeneriques().then((data) => {
      this.documentsGeneriquesOptions = data
    })
  }

  get content() {
    let str: any = ''
    this.list.map((item) => {
      if (item.DEFAUT) {
        const text = item.TEXTE
        str += `${text}\n\n`
      }
    })
    str += `\n${this.me.SIGNATURE_MAIL}`
    return str
  }

  @Watch('content', {deep: false})
  watchContent(val: any) {
    this.contentTextArea = val
  }

  addDocumentProspectHandler() {
    console.log('addDocumentProspectHandler')
  }

  async sendEmailHandler(id: number) {
    this.$v.$touch()
    if (!this.$v.$invalid) {
      if (this.desti.length !== 0) {
        const arrData = []
        this.desti.forEach((item) => {
          const index = arrData.findIndex((x) => x.ID_PROSPECT === item.ID_PROSPECT)
          if (index !== -1) {
            arrData[index].EMAILS.push(item.EMAIL)
          } else {
            arrData.push({
              ID_PROSPECT: item.ID_PROSPECT,
              EMAILS: [item.EMAIL]
            })
          }
        })
        const emailsFlat = arrData.flatMap((item) => item.EMAILS)
        const {ok} = await this.$dialogs.confirm(
          `Confirmez l'envoi de l'email à ${emailsFlat.join(', ')}` +
            (this.copieCachee.length !== 0 ? ` et en copie cachée à ${this.copieCachee.join(', ')}` : '') +
            ' ?',
          optionsVslim
        )
        if (ok) {
          this.isLoading = true
          // Documents Generiques
          const datasDocumentGenerique = await Promise.all(
            this.documentsGeneriques.map(async (item) => await this.getDocument(item))
          )
          const data = datasDocumentGenerique
          const bulkEmail = await Promise.allSettled(
            arrData.map(
              async (item) =>
                await this.sendEmail({
                  TO: item.EMAILS,
                  // CC: item.EMAILS.length > 1 ? item.EMAILS.slice(1).join(', ') : null,
                  BCC: this.copieCachee,
                  SUBJECT: this.sujetSelected,
                  PLAINTEXT: this.contentTextArea,
                  FICHIERS_ATTACHES: data,
                  ID_PROSPECT: item.ID_PROSPECT,
                  ID_CONSEILLER: this.me.ID,
                  DOCUMENTS_GENERIQUE: this.documentsGeneriques
                })
            )
          )
          this.isLoading = false
          // result
          const bad = bulkEmail.filter((item) => item.status === 'rejected')
          if (bad.length > 0) {
            Vue.notify({
              group: 'user',
              type: 'error',
              title: 'Erreur',
              text: "Une erreur est survenue lors de l'envoi des emails, veuillez réessayer"
            })
          } else {
            Vue.notify({
              group: 'user',
              type: 'success',
              title: 'Succès',
              text: 'Les emails ont bien été envoyés'
            })
            this.onCloseHandler()
          }
        }
      } else {
        const panel: any = document.querySelector('.slideout')
        if (panel) panel.scrollTop = 0
        Vue.notify({
          group: 'user',
          type: 'warn',
          title: 'Attention',
          text: 'Aucun destinataire sélectionné'
        })
      }
    } else {
      const panel: any = document.querySelector('.slideout')
      if (panel) panel.scrollTop = 0
    }
  }

  onCloseHandler() {
    this.$emit('closePanel', {})
  }

  onCopyHandler() {
    Vue.notify({
      group: 'user',
      type: 'success',
      title: 'Confirmation',
      text: "Le contenu de l'email a bien été copié dans le presse papier"
    })
  }

  onCopyErrorHandler() {
    Vue.notify({
      group: 'user',
      type: 'error',
      title: 'Erreur',
      text: "Le contenu de l'email n'a pas pu être copié dans le presse papier, veuillez réessayer"
    })
  }
}
